export default "/images/3e0310bc23de50f2adca3440492e65e2.avif";